import { useMediaQuery } from "@mui/material"
import InfoWeb from "./InfoWeb";
import InfoMob from "./InfoMob";
export default function Referral() {
    const isSmallScreen = useMediaQuery("(max-width:800px)");
    return isSmallScreen ? <InfoMob /> : <InfoWeb />;
}